import React, { useState } from "react";
import "../styles/donate_page.scss";
import { LiaRupeeSignSolid } from "react-icons/lia";
import CryptoJS from "crypto-js";
import { decrypt, encrypt } from "../utils/Encrypt";

const DonatePage = () => {
  const [selectedAmount, setSelectedAmount] = useState("");
  const [loader,setLoader] = useState(false)
  const [values, setValues] = useState({
    debtorName: "",
    debtorEmailId: "",
    finalDueAmount: "",
    additionalComments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleRadioChange = (e) => {
    setSelectedAmount(e.target.value);
    setValues({ ...values, finalDueAmount: e.target.value }); // ✅ Fix this condition
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoader(true)
      const clientId = "5169fv6m4ejarb2vlirpuqrjda";
      const clientSecret =
        "3o68d0b6ren50g7nu6bjfpb893bvl87flpcfgd6eorn5kbphjtl";

      const params = new URLSearchParams();
      params.append("grant_type", "client_credentials");
      params.append("client_id", clientId);
      params.append("client_secret", clientSecret);

      // 1. Get OAuth Token
      const tokenRes = await fetch(
        "https://bene-collect.auth.eu-west-2.amazoncognito.com/oauth2/token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: params.toString(),
        }
      );

      const tokenData = await tokenRes.json();
      const accessToken = tokenData.access_token;

      // 2. Create payload
      const payload = {
        collectionAmountCurrency: "INR",
        collectionReferenceNumber: crypto.randomUUID(),
        debtorEmailId: values.debtorEmailId,
        debtorName: values.debtorName,
        finalDueAmount: Number(values.finalDueAmount),
        requestorTransactionId: crypto.randomUUID(),
        reasonForCollection: "OnlineDonation",
        initialDueAmount: Number(values.finalDueAmount),
        charges: "0",
        reasonForCharges: "NA",
        additionalComments: values.additionalComments,
        // payVia: ["UI", "CC"],
       
      };

      // 3. Encrypt the payload using your AES-GCM function
      const encrypted = await encrypt(JSON.stringify(payload));
      

      const decrypted = await decrypt(encrypted);
     

      // 4. Send to BenePay
      const response = await fetch(
        "https://uat-api-collect-payment.benepay.io/v1/realTimeRequestToPay",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "m0OKyFypSF9Ndc8dLN8CW5QsKBWY0JoE7cYQNndb",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            encryptedData: encrypted,
          }),
        }
      );

      const data = await response.json();

      if (data.statusCode === 302 && data.message) {
        window.location.href = data.message; // redirect to payment
      } else {
        console.error("Payment initiation failed:", data);
      }
    } catch (err) {
      console.error("Error submitting payment:", err);
    }finally{
      setLoader(false)
    }
  };

  return (
    <div className="parent parent-donate-page">
      <div className="container-small cont-donate-page">
        <div className="donate-card-wrapper">
          <div className="left-donate bg-img"></div>
          <div className="right-donate">
            <form className="card" onSubmit={handleSubmit}>
              <h3>Make a Donation</h3>
              <p>
                Every donation, no matter how big or small, makes a significant
                difference to our cause. Thank you for doing your part to help.
              </p>
              <div className="input-wrapper">
                <p className="input-text">
                  <label>Name</label>
                  <input
                    onChange={handleChange}
                    name="debtorName"
                    value={values.debtorName}
                    type="text"
                  />
                </p>
                <p className="input-text">
                  <label>Email</label>
                  <input
                    onChange={handleChange}
                    name="debtorEmailId"
                    value={values.debtorEmailId}
                    type="text"
                  />
                </p>
              </div>

              <div className="donation-amount">
                <h4>Donation amount</h4>
                <div className="radio">
                  {[50, 100, 200, 500].map((amount) => (
                    <div className="amount-wrap" key={amount}>
                      <input
                        type="radio"
                        name="donation"
                        value={amount}
                        checked={selectedAmount === amount.toString()}
                        onChange={handleRadioChange}
                      />
                      <span>
                        <LiaRupeeSignSolid /> {amount}
                      </span>
                    </div>
                  ))}

                  <div className="amount-wrap">
                    <input
                      className="amount-input"
                      type="text"
                      name="finalDueAmount"
                      placeholder="Amount"
                      value={values.finalDueAmount}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <input
                type="text"
                name="additionalComments"
                value={values.additionalComments}
                onChange={handleChange}
                placeholder="Company Name (if applicable)"
              />

             

              <button type="submit" className="btn-active">
                {loader ? "Please Wait..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonatePage;
